import { I18N } from 'aurelia-i18n';
import { AccountPaymentItem } from '../../../../models/account-payment-item';
import { TransactionBalancePaymentType } from '../../../../models/enums/transaction-balance-payment-type';
import { IValidationRule } from '../i-validation-rule';
import { RuleValidationResult } from '../rule-validation-result';

export class VerifyOverPaymentsAllowedRule implements IValidationRule {
	constructor(private i18n: I18N, private items: AccountPaymentItem[]) { }

	validate(): RuleValidationResult {
		let result: RuleValidationResult = new RuleValidationResult();
		let isWarning: boolean = false;

		try {
			let isValid: boolean = true;
			this.items.forEach((i: AccountPaymentItem) => {

				if ((parseFloat(i.enteredAmount) || 0) > i.initialAmount) {
					i.paymentBalanceType = TransactionBalancePaymentType.OverPayment;
				}

				if (isValid &&
					i.isSelected &&
					i.paymentBalanceType === TransactionBalancePaymentType.OverPayment &&
					!i.paymentLimitSettings.allowOverPay) {
					isValid = false;
				} else if (isValid &&
					i.isSelected &&
					i.paymentBalanceType === TransactionBalancePaymentType.OverPayment &&
					i.paymentLimitSettings.allowOverPay &&
					i.paymentLimitSettings.enableOverPayWarningMessage) {
					isValid = false;
					isWarning = true;
				}
			});

			result.isValid = isValid;
			result.confirm = isWarning;
		}
		catch (err) {
			result.isValid = false;
		}

		if (!result.isValid) {
			if (isWarning) {
				result.errorMessage = this.i18n.i18next.t('overPaymentsWarning',
					'Account is being overpaid! Do you wish to continue?');
			} else {
				result.errorMessage = this.i18n.i18next.t('overPaymentsNotAllowed',
					'Payment Amount cannot be greater than the account balance.');
			}
		}

		return result;
	}
}
